import { Journey } from '../components/types/OptimizedMaps'

export const filterJourneysForUser = (userId: number, journeys: Journey[]): Journey[] =>
  journeys.filter(journey => journey.submitter.id === userId || journey.leader?.id === userId)
